import AccountPaper from '@/components/Account/AccountPaper'
import { Button } from '@evocolabs/orkaui'
import React from 'react'
import { Typography } from '@mui/material'
import i18n from 'i18next'
import k from '../../../../i18n/keys'
import { styled } from '@mui/material/styles'

const PREFIX = 'NoOrder'

const classes = {
  layoutContainerHead: `${PREFIX}-layoutContainerHead`,
  layoutContainerFoot: `${PREFIX}-layoutContainerFoot`,
  styleMyorders: `${PREFIX}-styleMyorders`,
  styleNoOrder: `${PREFIX}-styleNoOrder`,
  styleButton: `${PREFIX}-styleButton`
}

const Root = styled('div')(({ theme }) => {
  return {
    [`& .${classes.layoutContainerHead}`]: {},
    [`& .${classes.layoutContainerFoot}`]: {
      textAlign: 'center',
      marginTop: '16px'
    },

    [`& .${classes.styleMyorders}`]: {
      fontSize: '24px',
      fontWeight: 600,
      padding: '16px 0 16px 40px'
    },

    [`& .${classes.styleNoOrder}`]: {
      fontSize: '22px',
      fontWeight: 600,
      paddingTop: '200px'
    },

    [`& .${classes.styleButton}`]: {
      margin: '72px 0 160px',
      width: '375px'
    }
  }
})

function NoOrder() {
  return (
    <Root>
      <AccountPaper className={classes.layoutContainerHead}>
        <Typography className={classes.styleMyorders}>
          {i18n.t(k.MY_ORDERS)}
        </Typography>
      </AccountPaper>
      <AccountPaper className={classes.layoutContainerFoot}>
        <Typography variant="h5" className={classes.styleNoOrder}>
          {i18n.t(k.YOU_HAVEN_T_PLACED_ANY_ORDERS)}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          className={classes.styleButton}
          handleClick={() => {
            window.location.href = '/Product/buy-orka-two'
          }}
        >
          {i18n.t(k.GO_SHOPPING)}
        </Button>
      </AccountPaper>
    </Root>
  )
}

export default NoOrder
